import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { GetOrderOutputsByOrderResponse } from "./GetOrderOutputsByOrderResponse";

export const useOrderOutputApi = () => {
    const { httpGet } = useAuthorizedFetch();

    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/order-outputs`;

    const getOrderOutputsByOrder = async (orderId: string): Promise<GetOrderOutputsByOrderResponse> => {
        return httpGet<GetOrderOutputsByOrderResponse>(`${baseUrl}/get-by-order`, { orderId });
    };

    return {
        getOrderOutputsByOrder
    };
};
